module.exports = __webpack_public_path__ + "static/media/DqEveryChildExhibitionPhoto2.def790f4.jpg";